type GetFormData<T> = {
  form?: FormData
  formData: T
}

// TS Typeguard, checks if it's an iterable object containing files
function isFileList(value: unknown): value is Iterable<File> {
  return (
    value instanceof FileList ||
    (typeof value === 'object' &&
      value !== null &&
      Symbol.iterator in value &&
      !!Array.from(value as Iterable<unknown>).filter((x) => x instanceof File)
        .length)
  )
}

export const getFormData = <
  T extends { [key: string]: string | number | FileList | unknown | null }
>({
  form = new FormData(),
  formData,
}: GetFormData<T>): FormData => {
  Object.keys(formData).forEach((key: string) => {
    const value = formData[key]

    // Return if value is empty
    if (value === null || value === undefined) {
      return
    }

    appendFormData(form, key, value)
  })

  return form
}

export const appendFormData = (
  form: FormData,
  key: string,
  value: string | number | boolean | FileList | unknown
): void => {
  if (typeof value === 'string') {
    form.append(key, value)
  } else if (typeof value === 'number') {
    form.append(key, value.toString())
  } else if (typeof value === 'boolean') {
    form.append(key, value ? 'true' : 'false')
  } else if (isFileList(value)) {
    Array.from(value).forEach((value: File) => {
      form.append(key, value as File)
    })
  } else {
    throw new Error(`Unable to append ${key} to FormData, type not handled`)
  }
}
